var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Checkbox, Form, Modal, message, notification } from 'antd';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { WarningOutlined } from '@ant-design/icons';
import Input from '@fp-suite/core-ui/src/components/Input';
import Dropdown from '@fp-suite/core-ui/src/components/Dropdown';
import { PhotoAttachField, buildContainerPhotoName } from '../../camera';
import { useBetaPictureTakingEnabled } from '../../../utils/betaAccess';
import { fetchAttachments, uploadOrderPhotos } from '../../../redux/packing';
import { usePackingState, usePrinterConnection } from '../hooks';
import { useContainerActions } from '../hooks/useContainerActions';
import { useWeightStationHeartbeat } from '../weight/useWeightStationHeartbeat';
import { WeightStationHeartbeatIndicator } from '../weight/WeightStationHeartbeatIndicator';
import { getContainerDisplayId } from '../shared/containerHelpers';
import { boxKindForContainerType, filterBoxTypesForContainer, isPalletContainerType } from '../shared/boxTypeFilters';
var PALLET_WEIGHT_LBS = 35;
export var CloseContainerModal = function (_a) {
    var _b, _c, _d;
    var visible = _a.visible, container = _a.container, childContainers = _a.childContainers, onClose = _a.onClose, onClosed = _a.onClosed, onAutoPrintContainerLabel = _a.onAutoPrintContainerLabel;
    var containerId = (_b = container === null || container === void 0 ? void 0 : container.containerId) !== null && _b !== void 0 ? _b : null;
    var t = useTranslation().t;
    var betaPictureTakingEnabled = useBetaPictureTakingEnabled();
    var dispatch = useDispatch();
    var form = Form.useForm()[0];
    var _e = useState(false), isSubmitting = _e[0], setIsSubmitting = _e[1];
    var _f = useState(false), isWeightManuallyEdited = _f[0], setIsWeightManuallyEdited = _f[1];
    var _g = useState([]), photoFiles = _g[0], setPhotoFiles = _g[1];
    var _h = usePackingState(), shipmentId = _h.shipmentId, boxTypes = _h.boxTypes, loadBoxTypes = _h.loadBoxTypes, loading = _h.loading, loadPackageWeight = _h.loadPackageWeight, shipmentItemSourceList = _h.shipmentItemSourceList;
    var orderId = (_c = shipmentItemSourceList === null || shipmentItemSourceList === void 0 ? void 0 : shipmentItemSourceList[0]) === null || _c === void 0 ? void 0 : _c.orderId;
    var handleCloseContainer = useContainerActions().handleCloseContainer;
    var refreshQzHostname = usePrinterConnection().refreshQzHostname;
    var isConfirmLoading = !!(loading === null || loading === void 0 ? void 0 : loading.containerClose) || isSubmitting;
    var filteredBoxTypes = useMemo(function () { return filterBoxTypesForContainer(boxTypes, boxKindForContainerType(container === null || container === void 0 ? void 0 : container.containerTypeEnumId)); }, [boxTypes, container === null || container === void 0 ? void 0 : container.containerTypeEnumId]);
    var isPallet = isPalletContainerType(container === null || container === void 0 ? void 0 : container.containerTypeEnumId);
    var hasChildren = ((_d = childContainers === null || childContainers === void 0 ? void 0 : childContainers.length) !== null && _d !== void 0 ? _d : 0) > 0;
    var isSubContainer = (container === null || container === void 0 ? void 0 : container.isRoot) === false || Boolean(container === null || container === void 0 ? void 0 : container.parentContainerId);
    var _j = useMemo(function () {
        if (!hasChildren)
            return { missingChildren: [], childWeightSum: 0 };
        var missing = (childContainers || []).filter(function (c) { return !c.shipmentBoxTypeId || c.weight == null; });
        var sum = (childContainers || []).reduce(function (acc, c) { return acc + (Number(c.weight) || 0); }, 0);
        return { missingChildren: missing, childWeightSum: sum };
    }, [childContainers, hasChildren]), missingChildren = _j.missingChildren, childWeightSum = _j.childWeightSum;
    var hasMissingChildData = missingChildren.length > 0;
    var estimatedPalletWeight = isPallet && hasChildren ? childWeightSum + PALLET_WEIGHT_LBS : null;
    var showEstimatedPalletWeightHelper = estimatedPalletWeight != null && !isWeightManuallyEdited;
    var _k = useWeightStationHeartbeat({
        enabled: visible && !isPallet,
        shipmentId: shipmentId,
        shipmentPackageSeqId: undefined,
        loadPackageWeight: loadPackageWeight,
        onWeightReceived: function (weight) {
            form.setFieldsValue({ weight: String(weight) });
        }
    }), lastWeightReceivedAt = _k.lastWeightReceivedAt, weightAgeSeconds = _k.weightAgeSeconds, weightPulseClass = _k.weightPulseClass, hasActiveSource = _k.hasActiveSource, isQzConnected = _k.isQzConnected;
    useEffect(function () {
        if (!visible || !container)
            return;
        setIsWeightManuallyEdited(false);
        setPhotoFiles([]);
        if (!isPallet) {
            void refreshQzHostname(false);
        }
        var prefilledWeight = isPallet && hasChildren
            ? String(estimatedPalletWeight)
            : container.weight != null
                ? String(container.weight)
                : '';
        form.setFieldsValue({
            shipmentBoxTypeId: container.shipmentBoxTypeId || undefined,
            weight: prefilledWeight,
            autoPrintLabels: isSubContainer
        });
    }, [form, container, visible, isPallet, hasChildren, estimatedPalletWeight, refreshQzHostname, isSubContainer]);
    useEffect(function () {
        if (!visible)
            return;
        if (boxTypes.length === 0) {
            void loadBoxTypes();
        }
    }, [boxTypes.length, loadBoxTypes, visible]);
    var handleSubmit = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var values, resolvedHostname, _a, weightResult, _b, weightSourceMessage, formWeight, containerWeight, autoPrintLabels, uploadError_1, error_1;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!containerId || isConfirmLoading || hasMissingChildData)
                        return [2 /*return*/];
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 16, 17, 18]);
                    setIsSubmitting(true);
                    return [4 /*yield*/, form.validateFields(['shipmentBoxTypeId'])];
                case 2:
                    values = _d.sent();
                    if (!!isPallet) return [3 /*break*/, 4];
                    return [4 /*yield*/, refreshQzHostname()];
                case 3:
                    _a = _d.sent();
                    return [3 /*break*/, 5];
                case 4:
                    _a = null;
                    _d.label = 5;
                case 5:
                    resolvedHostname = _a;
                    if (!(!isPallet && shipmentId && resolvedHostname)) return [3 /*break*/, 7];
                    return [4 /*yield*/, loadPackageWeight(shipmentId)];
                case 6:
                    _b = _d.sent();
                    return [3 /*break*/, 8];
                case 7:
                    _b = null;
                    _d.label = 8;
                case 8:
                    weightResult = _b;
                    if (!isPallet &&
                        resolvedHostname &&
                        ((weightResult === null || weightResult === void 0 ? void 0 : weightResult.weight) === null || (weightResult === null || weightResult === void 0 ? void 0 : weightResult.weight) === undefined)) {
                        weightSourceMessage = "Scale: " + ((weightResult === null || weightResult === void 0 ? void 0 : weightResult.scaleComputerId) || 'Not returned') + ". Hostname: " + ((weightResult === null || weightResult === void 0 ? void 0 : weightResult.hostname) || 'Not sent') + ".";
                        notification['warning']({
                            message: t('Warning'),
                            description: t('Could not retrieve container weight from the scale or shipment.') + " " + weightSourceMessage
                        });
                    }
                    formWeight = form.getFieldValue('weight');
                    containerWeight = (_c = weightResult === null || weightResult === void 0 ? void 0 : weightResult.weight) !== null && _c !== void 0 ? _c : parseFloat(formWeight);
                    if (!Number.isNaN(containerWeight)) return [3 /*break*/, 10];
                    return [4 /*yield*/, form.validateFields(['weight'])];
                case 9:
                    _d.sent();
                    return [2 /*return*/];
                case 10:
                    autoPrintLabels = Boolean(form.getFieldValue('autoPrintLabels'));
                    return [4 /*yield*/, handleCloseContainer({
                            containerId: containerId,
                            shipmentBoxTypeId: values.shipmentBoxTypeId,
                            weight: containerWeight,
                            weightUomId: 'WT_lb'
                        })
                        // Upload only after the close succeeded, so a failed close leaves no orphan photos.
                    ];
                case 11:
                    _d.sent();
                    if (!(photoFiles.length && orderId)) return [3 /*break*/, 15];
                    _d.label = 12;
                case 12:
                    _d.trys.push([12, 14, , 15]);
                    return [4 /*yield*/, dispatch(uploadOrderPhotos({
                            orderId: orderId,
                            files: photoFiles,
                            description: String(t('Container photo'))
                        })).unwrap()];
                case 13:
                    _d.sent();
                    dispatch(fetchAttachments({ orderId: orderId }));
                    return [3 /*break*/, 15];
                case 14:
                    uploadError_1 = _d.sent();
                    notification['warning']({
                        message: t('Warning'),
                        description: t('Container closed, but the photos could not be attached.')
                    });
                    return [3 /*break*/, 15];
                case 15:
                    if (autoPrintLabels) {
                        onAutoPrintContainerLabel === null || onAutoPrintContainerLabel === void 0 ? void 0 : onAutoPrintContainerLabel(containerId);
                    }
                    form.resetFields();
                    setPhotoFiles([]);
                    onClosed();
                    return [3 /*break*/, 18];
                case 16:
                    error_1 = _d.sent();
                    if (error_1 === null || error_1 === void 0 ? void 0 : error_1.errorFields) {
                        return [2 /*return*/];
                    }
                    message.error(t('Failed to close container'));
                    return [3 /*break*/, 18];
                case 17:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 18: return [2 /*return*/];
            }
        });
    }); }, [
        form,
        handleCloseContainer,
        isConfirmLoading,
        onClosed,
        containerId,
        t,
        hasMissingChildData,
        isPallet,
        loadPackageWeight,
        refreshQzHostname,
        shipmentId,
        onAutoPrintContainerLabel,
        dispatch,
        orderId,
        photoFiles
    ]);
    var handleFormValuesChange = useCallback(function (changedValues) {
        if (Object.prototype.hasOwnProperty.call(changedValues, 'weight')) {
            setIsWeightManuallyEdited(true);
        }
    }, []);
    return (_jsx(Modal, __assign({ title: containerId ? t('Close Container') + " #" + containerId : t('Close Container'), visible: visible, onCancel: function () {
            if (isConfirmLoading)
                return;
            onClose();
        }, onOk: hasMissingChildData ? onClose : handleSubmit, okText: hasMissingChildData ? t('OK') : t('Close Container'), okButtonProps: { disabled: hasMissingChildData }, confirmLoading: isConfirmLoading, cancelButtonProps: { disabled: isConfirmLoading }, maskClosable: !isConfirmLoading, keyboard: !isConfirmLoading }, { children: hasMissingChildData ? (_jsxs("div", __assign({ className: 'rounded-lg border border-amber-200 bg-amber-50 p-3 text-amber-800' }, { children: [_jsxs("div", __assign({ className: 'flex items-center gap-2 font-semibold' }, { children: [_jsx(WarningOutlined, {}, void 0), _jsx("span", { children: t('Cannot close container') }, void 0)] }), void 0), _jsx("p", __assign({ className: 'mt-2 text-xs' }, { children: t('All sub-containers must have a box type and weight before this container can be closed.') }), void 0), _jsx("ul", __assign({ className: 'mt-2 space-y-1 text-xs' }, { children: missingChildren.map(function (child) {
                        var displayId = getContainerDisplayId(child);
                        var missing = [];
                        if (!child.shipmentBoxTypeId)
                            missing.push(t('Box Type'));
                        if (child.weight == null)
                            missing.push(t('Weight'));
                        return (_jsxs("li", { children: [_jsxs("span", __assign({ className: 'font-semibold' }, { children: ["#", displayId] }), void 0), ' — ', t('Missing'), ": ", missing.join(', ')] }, child.containerId));
                    }) }), void 0)] }), void 0)) : (_jsxs(Form, __assign({ form: form, layout: 'vertical', onValuesChange: handleFormValuesChange }, { children: [_jsx(Form.Item, __assign({ name: 'shipmentBoxTypeId', label: t('Box Type'), rules: [{ required: true, message: t('Please select box type') }] }, { children: _jsx(Dropdown, { searchable: true, placeholder: t('Select Box Type'), data: filteredBoxTypes }, void 0) }), void 0), _jsx(Form.Item, __assign({ name: 'weight', label: t('Container Weight (lbs)'), extra: showEstimatedPalletWeightHelper ? (_jsxs("span", __assign({ className: 'text-xs text-gray-500' }, { children: [t('Sub-container weight'), " ", childWeightSum, " lbs +", ' ', t('Pallet weight'), " ", PALLET_WEIGHT_LBS, " lbs"] }), void 0)) : undefined, rules: [
                        { required: true, message: t('Please enter container weight') },
                        { pattern: /^\d+(\.\d+)?$/, message: t('Enter a valid weight') }
                    ] }, { children: _jsx(Input, { title: '', inputType: 'number', placeholder: t('Scan weight'), autoFocus: true }, void 0) }), void 0), !hasChildren && (_jsx(WeightStationHeartbeatIndicator, { lastWeightReceivedAt: lastWeightReceivedAt, weightAgeSeconds: weightAgeSeconds, weightPulseClass: weightPulseClass, hasActiveSource: hasActiveSource, isQzConnected: isQzConnected }, void 0)), _jsx(Form.Item, __assign({ name: 'autoPrintLabels', valuePropName: 'checked', style: { marginBottom: 0 } }, { children: _jsx(Checkbox, { children: t('Auto-print container label') }, void 0) }), void 0), betaPictureTakingEnabled && orderId && (_jsx("div", __assign({ className: 'mt-3' }, { children: _jsx(PhotoAttachField, { files: photoFiles, onChange: setPhotoFiles, disabled: isConfirmLoading, label: String(t('Add Photo')), modalTitle: String(t('Container Photo')), buildFileName: function (shotIndex) {
                            return buildContainerPhotoName(String(shipmentId), (container === null || container === void 0 ? void 0 : container.containerSeqNum) || containerId || '', shotIndex);
                        } }, void 0) }), void 0))] }), void 0)) }), void 0));
};
export default CloseContainerModal;
